import './index.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BotTagManagerPopover } from '../Popover';

export class BotTagDisplay extends Component {
  prepareTags() {
    // Check for missing
    const [
      tag1UUID,
      tag2UUID,
      ...rest
    ] = this.props.item.bot_tag_ids.filter((uuid) =>
      Boolean(this.props.botTagsById[uuid])
    );
    if (!tag1UUID) {
      return null;
    }
    if (!tag2UUID) {
      return this.props.botTagsById[tag1UUID].name;
    }

    const tagString = [tag1UUID, tag2UUID]
      .map((uuid) => this.props.botTagsById[uuid].name)
      .join(', ');
    if (!rest.length) {
      return tagString;
    }
    return `${tagString} +${rest.length} more`;
  }

  render() {
    return (
      <div
        className="BotTagDisplay"
        onClick={((event) => event.stopPropagation()).bind(this)}
      >
        <BotTagManagerPopover
          controlled={this.props.controlled}
          item={this.props.item}
          onChange={this.props.onChange}
        >
          {this.prepareTags() || '+ Add tag'}
        </BotTagManagerPopover>
      </div>
    );
  }
}

BotTagDisplay.defaultProps = {
  item: {},
  onChange: () => {},
  controlled: false,
};

const mapStateToProps = (state) => {
  return {
    botTagIds: state.bot_tags.ids,
    botTagsById: state.bot_tags.byId,
  };
};

export default connect(mapStateToProps)(BotTagDisplay);
